/**
 * AYRON Product Page interactions.
 * Vanilla JS, event-delegated from document so it keeps working after
 * Shopify section reloads in the theme editor (no re-init needed).
 */

document.addEventListener('click', (event) => {
  // ── Tabs ──────────────────────────────────────────────────────────────
  const tabBtn = event.target.closest('.ayron-tabs__btn');
  if (tabBtn) {
    const tabs = tabBtn.closest('.ayron-tabs');
    if (!tabs) return;
    const targetId = tabBtn.getAttribute('aria-controls');

    tabs.querySelectorAll('.ayron-tabs__btn').forEach((btn) => {
      btn.setAttribute('aria-selected', btn === tabBtn ? 'true' : 'false');
    });
    tabs.querySelectorAll('.ayron-tabs__panel').forEach((panel) => {
      if (panel.id === targetId) {
        panel.setAttribute('data-active', '');
      } else {
        panel.removeAttribute('data-active');
      }
    });
    return;
  }

  // ── Size guide dialog open ──────────────────────────────────────────────
  const guideTrigger = event.target.closest('[data-ayron-size-guide-open]');
  if (guideTrigger) {
    const dialogId = guideTrigger.getAttribute('data-ayron-size-guide-open');
    const dialog = document.getElementById(dialogId);
    if (dialog && typeof dialog.showModal === 'function') {
      dialog.showModal();
    }
    return;
  }

  // ── Size guide dialog close (close button or backdrop click) ───────────
  const guideClose = event.target.closest('[data-ayron-size-guide-close]');
  if (guideClose) {
    const dialog = guideClose.closest('dialog');
    if (dialog) dialog.close();
    return;
  }

  if (event.target.tagName === 'DIALOG' && event.target.classList.contains('ayron-size-guide__dialog')) {
    event.target.close();
  }
});
